// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1437":"css/app.7005","3590":"css/admin-app.7005"}[chunkId] + ".css";
};